import React from 'react'
import '../styles/Footer.css'

function Footer() {
  return (
    <div className='footer'>
        <span>
            <p>&copy; 2022 | Designed and Built by Team Horus</p>
            <p>Dheeraj | Bhargav</p>
        </span>
    </div>
  )
}

export default Footer